module.exports = __webpack_public_path__ + "img/canal-do-midia.d6b79d9d.svg";